   function toggleArrows(rowElement) {
        let arrowIndicator = rowElement.querySelector('svg')

         if (arrowIndicator) {
              arrowIndicator.classList.toggle('open')
        }
  }



  let mainMobileRows = document.querySelectorAll('.mobile-menu__main-item .main-row');
  let mainMenuItems = document.querySelectorAll('.main-menu-item');
  let subMenuItems = document.querySelectorAll('.sub-menu-item');
  let subMenuRows = document.querySelectorAll('.mobile-menu__main-item .submenu-row');
  let grandMenu = document.querySelectorAll('.grand-submenu');
  let subMenus = document.querySelectorAll('.submenu-data');


  subMenuRows.forEach((row, index) => {
                let arrow = row.querySelector('svg');
                if (!arrow) return;
                arrow.style.cursor = 'pointer';
                arrow.onclick = function (e) {
                  e.preventDefault();
                  e.stopPropagation();

                let container = subMenuItems[index];
                let menuDropdown = grandMenu[index];
                if (menuDropdown) {
                     let height = menuDropdown.clientHeight + row.clientHeight;
                      let mainParent = row.parentNode.parentNode;
                      let parentIndex = Array.from(subMenus).indexOf(mainParent);


                  if (container.classList.contains('details-open')) {
                      container.removeAttribute('style');
                  } else {
                      container.style.height = `${height}px`
                  }

                  toggleArrows(row)

                 setTimeout(() => {
                           let totalHeight = subMenus[parentIndex].clientHeight + mainMobileRows[parentIndex].clientHeight;
                            mainMenuItems[parentIndex].style.height = `${totalHeight}px`
                        }, 250)

                  container.classList.toggle('details-open')

                }


                }
               })

  mainMobileRows.forEach((row, index) => {
    let arrow = row.querySelector('svg');
    if (!arrow) return;
    arrow.style.cursor = 'pointer';
    arrow.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let submenu = document.querySelectorAll('.mobile-menu__main-item .submenu-data')[index];
            let container = mainMenuItems;
            let containerIndex = index


                if (submenu) {

                if (container[containerIndex].classList.contains('options-open')) {
                  container[containerIndex].removeAttribute('style')
                let subItems = container[containerIndex].querySelectorAll('.sub-menu-item');

                clearSubMenuItemState(subItems)

                } else {
                  container.forEach(item => {
                    item.removeAttribute('style');
                    item.classList.remove('options-open');
                    let caret = item.querySelector('svg.icon.icon-caret');
                    if (caret) caret.classList.remove('open');
                    clearSubMenuItemState(item.querySelectorAll('.sub-menu-item'))
                  })
                  let menuHeight = row.clientHeight + submenu.clientHeight;
                  container[containerIndex].style.height = `${menuHeight}px`
                }

                  container[containerIndex].classList.toggle('options-open')

                   let subMenuHeight =  submenu.clientHeight;

                 toggleArrows(row)
                }


    })
  })

function clearSubMenuItemState(subItems) {
  
                  if (subItems.length > 0) {
                    subItems.forEach(item => {
                      item.removeAttribute('style');
                      item.classList.remove('details-open');

                      let arrow = item.querySelector('svg');

                      if (arrow) {
                        arrow.classList.remove('open')
                      }
                    })
                  }
}